export default __webpack_public_path__ + "static/media/Flag_of_Costa_Rica.9590a2b8.svg";